export const buildContentShareUrl = (contentId) => {
    if (!contentId) return window.location.href;

    const url = new URL(window.location.href);
    url.searchParams.set('contentId', String(contentId));
    url.hash = '';
    return url.toString();
};

export const shareContentLink = async (contentId, options = {}) => {
    const shareUrl = buildContentShareUrl(contentId);
    const shareTitle = options.title || 'Check this post';
    const shareText = options.text || 'Take a look at this post on Shipway';

    if (navigator.share) {
        try {
            await navigator.share({
                title: shareTitle,
                text: shareText,
                url: shareUrl
            });
            return { shareUrl, shared: true, canceled: false };
        } catch (error) {
            if (error?.name === 'AbortError') {
                return { shareUrl, shared: false, canceled: true };
            }
            throw error;
        }
    }

    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(shareUrl);
        return { shareUrl, shared: false, copied: true, canceled: false };
    }

    return { shareUrl, shared: false, copied: false, canceled: false };
};
